import ContactNotesFormEmail from '../ContactNoteFormEmail';
import ContactNotesFormDialog from '../ContactNotesFormDialog';
import withInitialValuesFromContactNotes from './withInitialValuesfromContactNotes';
import withInitialValuesFromContactNotesHome from './withInitialValuesfromContactNotesHome';
import withInitialValuesFromEmailContactNotes from './withInitialValuesFromEmailContactNotes';

// EnhancedContactNotesFormDialog is for partner/br screen, some api is dependent on techId provided on URL
// EnhancedContactNotesHomeFormDialog doesn't use postMessage to retrieve data and has edit flow comparing to EnhancedEmailContactNotesFormDialog
const EnhancedContactNotesFormDialog = withInitialValuesFromContactNotes(ContactNotesFormDialog);
const EnhancedContactNotesHomeFormDialog = withInitialValuesFromContactNotesHome(ContactNotesFormDialog);
const EnhancedEmailContactNotesFormDialog = withInitialValuesFromEmailContactNotes(ContactNotesFormEmail);
export { EnhancedContactNotesFormDialog, EnhancedEmailContactNotesFormDialog, EnhancedContactNotesHomeFormDialog };
